// 
export const DOMAIN = 'https://api.covid19api.com';
export const ACCESSTOKEN = 'ACCESSTOKEN';